import { StyleSheet } from "react-native";
import { appColors } from "../../appTheme";

export const commonHeaderStyle = StyleSheet.create({
    outerContainer: {
        backgroundColor: appColors?.light,
        padding: 20,
        paddingHorizontal: 15,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    innercontainer: {
        flexDirection: "row",
        alignItems: "center",
    }
})